import axios from "axios";
import { ErroMsg } from "../../frontend/contents/VariaveisGlobais";

// Reutilização de instância do axios com configurações padrão
const URL = window._env_?.REACT_APP_URL || process.env.REACT_APP_URL
const Port = window._env_?.REACT_APP_PORT || process.env.REACT_APP_PORT

const api = axios.create({
    baseURL: `${URL}:${Port}/api`,
    withCredentials: true, // 🔒 envia cookie automaticamente
    headers: {
        "Content-Type": "application/json",
        "Accept": "*/*",
        "Cache-Control": "no-cache, no-store, must-revalidate"
    }
});

async function ConsultaAPI(cConsulta) {
    try {
        const response = await api.get('/consultas', {
            params: { query: cConsulta }
        });
        return response.data;
    } catch (err) {
        ErroMsg('Falha ao Processar Consulta! ' + err.message);
        return { data: [], error: err.message };
    }
}

async function ConsultaAPI_URL(rota) {
    try {
        const response = await api.get(`/${rota}`);
        return response.data;
    } catch (err) {
        return { data: [], error: err.message };
    }
}

async function ConsultaAPI_URLQuery(cUrl, cQuery, showMsg = true) {
    try {
        const response = await api.get(`/${cUrl}`, {
            params: { query: cQuery }
        });
        return response.data;
    } catch (err) {
        if (showMsg) {
            ErroMsg('Falha ao Processar! ' + err.message);
        }
        return { data: [], error: err.message };
    }
}

export { ConsultaAPI, ConsultaAPI_URL, ConsultaAPI_URLQuery };
